(function () {
    "use strict";

    angular
        .module("iMatApp")
        .factory("processStatusChecker", processStatusChecker);

    processStatusChecker.$inject = ["$q", "$log", 'poller', "modelProcessingService"];

    function processStatusChecker($q, $log, poller, modelProcessingService) {
        return {
            run: run
        };

        function run(modelId, intervalMs, canceler) {
            var lastStatusCode = null;
            var waitPromise = $q.defer();
            
            var requestUrl = modelProcessingService.getProcessStatusUrl(modelId);
            var statusPoller = poller.get(requestUrl, {
                delay: intervalMs,
                argumentsArray: [modelId],
                smart: true,
                catchError: true
            });

            if (angular.isDefined(canceler)) {
                canceler.then(function () {
                    $log.debug("ABORT process status checker");
                    statusPoller.stop();
                    waitPromise.reject('CANCELED');
                });
            }

            statusPoller.promise.then(null, null, function (response) {
                if (response.status !== 200) {
                    statusPoller.stop();
                    waitPromise.reject('Check status of processing model failed');
                    return;
                }

                var status = modelProcessingService.extendStatusInfo(response.data);
                if (status.code !== lastStatusCode) {
                    lastStatusCode = status.code;
                    waitPromise.notify(status);
                }

                if (status.isDone()) {
                    statusPoller.stop();
                    waitPromise.resolve();
                }
            });

            return waitPromise.promise;
        }
    }
}());